var _g, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitCardYor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 108,
    viewBox: "0 0 244 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_2164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    y: 0.853027,
    width: 243.2,
    height: 107,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.74 74.4998C274.124 68.5039 269.131 63.4205 263.172 59.6684C257.213 55.9163 250.458 53.6027 243.465 52.9184C236.472 52.234 229.439 53.1984 222.947 55.7321C216.455 58.2658 210.69 62.2963 206.125 67.4917C201.56 72.687 198.327 78.8985 196.692 85.6146C195.057 92.3306 195.066 99.3591 196.72 106.121C198.373 112.883 201.623 119.185 206.202 124.507C210.782 129.83 216.559 134.021 223.058 136.736L231.164 117.207C227.817 115.809 224.842 113.65 222.484 110.909C220.125 108.167 218.451 104.922 217.6 101.439C216.748 97.9568 216.743 94.337 217.585 90.8781C218.427 87.4192 220.093 84.2201 222.444 81.5444C224.795 78.8687 227.764 76.7929 231.108 75.488C234.451 74.1831 238.073 73.6864 241.675 74.0388C245.276 74.3913 248.755 75.5828 251.824 77.5152C254.893 79.4477 257.465 82.0657 259.327 85.1538L277.74 74.4998Z",
    fill: "#3D76F8",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.017 24.0944C132.658 2.68847 139.654 -24.4878 160.642 -36.6055C181.631 -48.7232 208.664 -41.1936 221.023 -19.7876C233.381 1.61827 226.386 28.7945 205.397 40.9122C184.409 53.0299 157.375 45.5003 145.017 24.0944ZM202.592 -9.14675C196.227 -20.1713 182.304 -24.0492 171.495 -17.8083C160.685 -11.5674 157.082 2.42896 163.447 13.4535C169.812 24.478 183.735 28.3559 194.545 22.1151C205.354 15.8742 208.957 1.87778 202.592 -9.14675Z",
    fill: "#3D76F8",
    fillOpacity: 0.08
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.900024,
    y: 1.35303,
    width: 242.2,
    height: 106,
    rx: 15.5,
    stroke: "url(#paint0_linear_141_2164)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.900024,
    y: 1.35303,
    width: 242.2,
    height: 106,
    rx: 15.5,
    stroke: "#D0DEFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_2164",
    x1: 10.4971,
    y1: 6.25321,
    x2: 213.718,
    y2: 141.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_2164"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.400024,
    y: 0.853027,
    width: 243.2,
    height: 107,
    rx: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardYor);
export default __webpack_public_path__ + "static/media/benefitCardYor.87b7a7f711db3135321fab56eebc1ad3.svg";
export { ForwardRef as ReactComponent };